import { NSARouterMakerResult } from "namirasoft-account-react";
import { Component } from "react";
import { InferenceEntities } from "../InferenceEntities";
import { InferenceInfo } from "../InferenceInfo";
import { InferenceLayout } from '../InferenceLayout';
import { InferenceRouterProps } from "../InferenceRouterProps";

interface WiperListPageProps extends NSARouterMakerResult, InferenceRouterProps { }

export default class WiperListPage extends Component<WiperListPageProps>
{
    override render()
    {
        return (
            <InferenceLayout
                {...this.props}
                action={{ description: InferenceInfo.wiper.list }}
                pages={{
                    entity: InferenceEntities.wiper(this.props),
                    list: {}
                }}
            >
                <></>
            </InferenceLayout>
        );
    }
}